import { render } from "./door-sales-recent-sales.vue?vue&type=template&id=301f5aa3&scoped=true"
import script from "./door-sales-recent-sales.vue?vue&type=script&lang=js"
export * from "./door-sales-recent-sales.vue?vue&type=script&lang=js"

import "./door-sales-recent-sales.vue?vue&type=style&index=0&id=301f5aa3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301f5aa3"]])

export default __exports__